import { defineChain } from "viem";

// ARC Mainnet — chain ID 5042, native gas/settlement asset USDC (6 decimals)
export const arc = defineChain({
  id: 5042,
  name: "ARC Mainnet",
  nativeCurrency: { name: "USD Coin", symbol: "USDC", decimals: 6 },
  rpcUrls: { default: { http: ["https://rpc.arc-scan.org"] } },
  blockExplorers: {
    default: { name: "ARC Scan", url: "https://arc-scan.org" },
  },
});
